// XEN-266: application UI scope is EN/DE/PL. Keep French resources and guest
// communication/document languages; they are not selectable UI languages.
export const UI_LANGUAGE_OPTIONS = [
  { value: "de", label: "Deutsch" },
  { value: "en", label: "English" },
  { value: "pl", label: "Polski" },
] as const;

export type UiLanguage = typeof UI_LANGUAGE_OPTIONS[number]["value"];
export const DEFAULT_UI_LANGUAGE: UiLanguage = "de";

export function normalizeUiLanguage(value: string | null | undefined): UiLanguage | null {
  const normalized = value?.trim().toLowerCase().split("-")[0];
  return UI_LANGUAGE_OPTIONS.find(option => option.value === normalized)?.value ?? null;
}
